export default __webpack_public_path__ + "static/media/MajaLovelace.e9bc8998.png";